import { Skeleton } from "@mui/material";

export default function NonTrendFoodMenuItemSkeleton() {
  return (
    <>
      <Skeleton
        variant="text"
        sx={{ width: "20%", marginTop: 5 }}
        animation="wave"
      />
      <Skeleton
        variant="rectangular"
        animation="wave"
        sx={{
          borderRadius: "7px",
          width: "50%",
          height: {
            xs: "120px",
            sm: "150px",
            md: "200px",
          },
        }}
      />
      <Skeleton variant="text" sx={{ width: "20%" }} animation="wave" />
      <Skeleton variant="text" sx={{ width: "20%" }} animation="wave" />
    </>
  );
}